import { useState } from "react";
import { C, Card, CardHead, SectionTitle, Btn, Badge, Bar, Dot } from "./theme";
import { useLang } from "./i18n";

export default function AdminPorts(props) {
  const { vms, services, getServerIp } = props;
  const { t } = useLang();
  const [tab, setTab] = useState("ssh");

  const activeVms = vms.filter(v => v.status !== "reclaimed");
  const byServer = {};
  activeVms.forEach(v => {
    if (!byServer[v.server]) byServer[v.server] = [];
    byServer[v.server].push(v);
  });
  const svcByVm = {};
  (services || []).forEach(s => {
    if (!svcByVm[s.vm_id]) svcByVm[s.vm_id] = [];
    svcByVm[s.vm_id].push(s);
  });

  const thS = { textAlign:"left", padding:"8px 10px", fontWeight:600, fontSize:9, color:C.dim2, letterSpacing:1, textTransform:"uppercase" };
  const tdS = { padding:"8px 10px" };

  return (
    <div>
      <SectionTitle title={t("port_status")}/>
      <div style={{ display:"flex", gap:6, marginBottom:14 }}>
        {[{k:"ssh",l:t("ssh_ports")},{k:"services",l:t("service_ports_tab")},{k:"ranges",l:t("port_range_viz")}].map(tb =>
          <Btn key={tb.k} small variant={tab===tb.k?"blue":"ghost"} onClick={()=>setTab(tb.k)}>{tb.l}</Btn>
        )}
      </div>

      {tab==="ssh" && (
        <Card style={{ overflowX:"auto" }}>
          <table style={{ width:"100%", borderCollapse:"collapse", fontSize:11 }}>
            <thead>
              <tr style={{ borderBottom:`1px solid ${C.border}` }}>
                {[t("vm_id"),t("users"),t("server"),t("ssh_ports"),t("status"),t("connect_info")].map(h =>
                  <th key={h} style={thS}>{h}</th>
                )}
              </tr>
            </thead>
            <tbody>
              {activeVms.sort((a,b)=>(a.ssh_port||0)-(b.ssh_port||0)).map(v => (
                <tr key={v.id} style={{ borderBottom:`1px solid ${C.border}08` }}>
                  <td style={tdS}><span style={{color:C.cyan,fontFamily:"monospace",fontWeight:700}}>{v.id}</span></td>
                  <td style={tdS}>{v.user_id}</td>
                  <td style={tdS}>{v.server}</td>
                  <td style={tdS}><Badge label={String(v.ssh_port)} color={C.cyan}/></td>
                  <td style={tdS}><Dot color={v.status==="running"?C.green:C.dim2}/></td>
                  <td style={tdS}><span style={{fontFamily:"monospace",fontSize:10,color:C.dim2}}>
                    ssh -p {v.ssh_port} {v.user_id}@{getServerIp?.(v.server)||v.server}
                  </span></td>
                </tr>
              ))}
              {activeVms.length===0&&<tr><td colSpan={6} style={{...tdS,textAlign:"center",color:C.dim2}}>{t("no_vm")}</td></tr>}
            </tbody>
          </table>
        </Card>
      )}

      {tab==="services" && (
        <Card style={{ overflowX:"auto" }}>
          <table style={{ width:"100%", borderCollapse:"collapse", fontSize:11 }}>
            <thead>
              <tr style={{ borderBottom:`1px solid ${C.border}` }}>
                {[t("vm_id"),t("port_range"),t("service_name"),t("vm_port"),t("host_port"),t("access"),t("status")].map(h =>
                  <th key={h} style={thS}>{h}</th>
                )}
              </tr>
            </thead>
            <tbody>
              {activeVms.map(v => {
                const vmSvcs = svcByVm[v.id]||[];
                if (vmSvcs.length===0) return (
                  <tr key={v.id} style={{borderBottom:`1px solid ${C.border}08`}}>
                    <td style={tdS}><span style={{color:C.cyan,fontFamily:"monospace"}}>{v.id}</span></td>
                    <td style={tdS}><span style={{fontFamily:"monospace",fontSize:10,color:C.dim2}}>{v.port_range_start}-{v.port_range_end}</span></td>
                    <td colSpan={5} style={{...tdS,color:C.dim2,fontSize:10}}>{t("no_services")}</td>
                  </tr>
                );
                return vmSvcs.map((svc,i) => (
                  <tr key={`${v.id}-${svc.id}`} style={{borderBottom:`1px solid ${C.border}08`}}>
                    {i===0&&<>
                      <td style={tdS} rowSpan={vmSvcs.length}><span style={{color:C.cyan,fontFamily:"monospace"}}>{v.id}</span></td>
                      <td style={tdS} rowSpan={vmSvcs.length}><span style={{fontFamily:"monospace",fontSize:10,color:C.dim2}}>{v.port_range_start}-{v.port_range_end}</span></td>
                    </>}
                    <td style={tdS}>{svc.name}</td>
                    <td style={tdS}><span style={{fontFamily:"monospace"}}>{svc.vm_port}</span></td>
                    <td style={tdS}><Badge label={String(svc.host_port||"-")} color={C.cyan}/></td>
                    <td style={tdS}><Badge label={svc.access} color={svc.access==="external"?C.green:C.amber}/></td>
                    <td style={tdS}><Dot color={svc.status==="running"?C.green:C.dim2}/></td>
                  </tr>
                ));
              })}
            </tbody>
          </table>
        </Card>
      )}

      {tab==="ranges" && (
        <div style={{ display:"grid", gap:14 }}>
          {Object.keys(byServer).map(sid => {
            const sVms = byServer[sid].sort((a,b)=>(a.port_range_start||0)-(b.port_range_start||0));
            return (
              <Card key={sid}>
                <CardHead>
                  <span style={{fontWeight:700,color:C.text,fontFamily:"'Rajdhani',sans-serif"}}>{sid}</span>
                  <span style={{color:C.dim2,fontSize:10}}>{sVms.length} VMs</span>
                </CardHead>
                <div style={{ padding:14, display:"flex", flexDirection:"column", gap:6 }}>
                  {sVms.map(v => {
                    const rangeSize = (v.port_range_end||0)-(v.port_range_start||0);
                    const usedPorts = (svcByVm[v.id]||[]).length;
                    return (
                      <div key={v.id} style={{display:"flex",alignItems:"center",gap:8}}>
                        <span style={{color:C.cyan,fontFamily:"monospace",fontSize:10,minWidth:80}}>{v.id}</span>
                        <div style={{flex:1,position:"relative",height:18,background:C.bg,borderRadius:4,overflow:"hidden",border:`1px solid ${C.border}`}}>
                          {rangeSize>0&&<div style={{position:"absolute",left:0,top:0,bottom:0,
                            width:`${Math.max((usedPorts/Math.max(rangeSize,1))*100,usedPorts>0?3:0)}%`,
                            background:C.cyan+"44",borderRadius:4}}/>}
                          <div style={{position:"absolute",left:6,top:0,bottom:0,display:"flex",alignItems:"center",
                            fontSize:9,color:C.text,fontFamily:"monospace"}}>
                            {v.port_range_start}-{v.port_range_end} ({usedPorts}/{rangeSize})
                          </div>
                        </div>
                        <Badge label={v.status} color={v.status==="running"?C.green:C.dim2}/>
                      </div>
                    );
                  })}
                </div>
              </Card>
            );
          })}
          {Object.keys(byServer).length===0&&<Card style={{textAlign:"center",color:C.dim2,padding:32}}>{t("no_vm")}</Card>}
        </div>
      )}
    </div>
  );
}
